import { render, staticRenderFns } from "./AddressContainer.vue?vue&type=template&id=a23c3af8&"
import script from "./AddressContainer.vue?vue&type=script&lang=js&"
export * from "./AddressContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports